import ExpeditorsTracking from '../views/tracking/Expeditors';
import TrackingHome from '../views/tracking/TrackingHome';
import { routeNames } from '../constants';

export default [
  {
    path: '/tracking',
    redirect: { name: routeNames.home },
    component: TrackingHome,
    // Using webpack chunk causes flash of login screen on first load
    // component: () => import(/* webpackChunkName: 'tracking' */ '../views/tracking/TrackingHome'),
    children: [
      {
        path: 'expeditors',
        name: routeNames.tracking.expeditors,
        component: ExpeditorsTracking,
        props: (route) => ({ ...route.query, ...route.params }),
        meta: {
          openAccess: true, // allow route to be viewed without authentication
          noLayout: true,
        },
      },
      {
        path: '*',
        redirect: { name: routeNames.notFound },
      },
    ],
  },
];
